import { FC } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  selectOptionForPolicy,
  restorePolicySettings,
} from '../actions/policy-settings-actions';
import { PolicySetting as PolicySettingType } from '../policy-settings-types';
import PolicySetting from './PolicySetting';

const PolicyTable: FC<React.PropsWithChildren<PolicyTableProps>> = ({
  categoryId,
  settings,
}) => {
  return (
    <Table sx={{ width: '100%' }}>
      <TableHead>
        <TableRow>
          <TableCell>Policy Name</TableCell>
          <TableCell>New Issues</TableCell>
          <TableCell>Old Issues</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {settings.map(setting => (
          <TableRow key={setting.policyId}>
            <TableCell>{setting.policyName}</TableCell>
            <TableCell>
              <PolicySetting
                categoryId={categoryId}
                policyId={setting.policyId}
                options={setting.options.new}
                type='new'
                onOptionSelect={selectOptionForPolicy}
              />
            </TableCell>
            <TableCell>
              <PolicySetting
                options={setting.options.old}
                categoryId={categoryId}
                policyId={setting.policyId}
                type='old'
                onOptionSelect={selectOptionForPolicy}
              />
            </TableCell>
            <TableCell align='right'>
              <Button
                sx={{ width: 150 }}
                disabled={!setting.hasChanged}
                onClick={() => {
                  restorePolicySettings(setting.policyId, categoryId);
                }}>
                Reset Changes
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export interface PolicyTableProps {
  categoryId: string;
  settings: PolicySettingType[];
}

export default PolicyTable;
